import { connect, ConnectedProps } from "react-redux";
import { slotTemplatesSelector, actions } from "reducers/slotTemplates";
import { SlotTemplatesFilterType } from "reducers/types/slotTemplates";
import { AppDispatch, RootState } from "store";
import SlotsTemplates from "./SlotsTemplates";
import useBasicData from "hooks/useBasicData";
import { SlotsTemplatesContainerPropsType } from "./types";
import { useEffect } from "react";

const SlotsTemplatesContainer = (
  props: SlotsTemplatesContainerPropsType & ConnectorProps
): JSX.Element => {
  const { regions } = useBasicData(["regions"]);
  const onDetailModalClose = () => {
    props.toggleDetailModalVisibility(false);
    props.getTemplates({
      ...props.filters,
      ...props.filtersExtra,
    });
  };

  const onCreationModalClose = () => {
    props.toggleCreationModalVisibility(false);
    props.getTemplates({
      ...props.filters,
      ...props.filtersExtra,
    });
  };

  useEffect(() => {
    props.setCollapseTable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SlotsTemplates
      {...props}
      data-testid="slot-templates"
      regions={regions}
      onDetailModalClose={onDetailModalClose}
      onCreationModalClose={onCreationModalClose}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  showCreationModal: slotTemplatesSelector(state).showCreationModal,
  showDetailModal: slotTemplatesSelector(state).showDetailModal,
  filters: slotTemplatesSelector(state).filters,
  filtersExtra: slotTemplatesSelector(state).filtersExtra,
  overlappedTemplates: slotTemplatesSelector(state).overlappedTemplates,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  toggleCreationModalVisibility: (show: boolean) => {
    dispatch(actions.toggleCreationModalVisibility(show));
  },
  toggleDetailModalVisibility: (show: boolean) => {
    dispatch(actions.toggleDetailModalVisibility(show));
  },
  getTemplates: (params: SlotTemplatesFilterType) => {
    dispatch(actions.getSlotTemplatesRequest(params));
  },
  clearOverlappedTemplates: () => {
    dispatch(actions.setOverlappedTemplates([]));
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(actions.setCollapseTable(collapse));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlotsTemplatesContainer);
